import React from 'react';
import { Plus } from 'lucide-react';
import { Handle, Position, NodeProps } from 'reactflow';

interface AddNodeData {
  onAdd: (parentNodeId?: string) => void;
  parentNodeId?: string;
}

const AddNode: React.FC<NodeProps<AddNodeData>> = ({ data }) => {
  const { onAdd, parentNodeId } = data;
  
  const handleClick = () => {
    if (typeof onAdd === 'function') {
      onAdd(parentNodeId);
    } else {
      console.error('[ERROR] AddNode - onAdd is not a function:', onAdd);
    }
  };
  
  return (
    <div className="relative group flex flex-col items-center justify-center w-12 h-12 bg-white dark:bg-cap-dark border-2 border-primary-400 rounded-full shadow cursor-pointer hover:bg-primary-50" onClick={handleClick} data-tutorial="btn-add-step">
      <Plus className="w-6 h-6 text-primary-600" />
      <div className="absolute left-1/2 top-full mt-2 -translate-x-1/2 px-2 py-1 rounded bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap shadow-lg z-20">
        Add Step
      </div>
      <Handle type="target" position={Position.Top} id="top" style={{ top: 0, left: '50%', transform: 'translate(-50%, -50%)' }} className="w-3 h-3 bg-primary-400" />
      <Handle type="target" position={Position.Left} id="left" style={{ left: 0, top: '50%', transform: 'translate(-50%, -50%)' }} className="w-3 h-3 bg-primary-400" />
      <Handle type="target" position={Position.Right} id="right" style={{ right: 0, top: '50%', transform: 'translate(50%, -50%)' }} className="w-3 h-3 bg-primary-400" />
      <Handle type="target" position={Position.Bottom} id="bottom" style={{ left: '50%', bottom: 0, transform: 'translate(-50%, 50%)' }} className="w-3 h-3 bg-primary-400" />
    </div>
  );
};

export default AddNode; 